'use client'

import { Cell, Checkbox, Label, Radio, Text } from '@vinted/web-ui'
import { ReactComponentElement, ReactNode } from 'react'

import { FilterGroupModel } from '@marketplace-web/catalog/catalog-data'

import SelectableItemList, { SelectableListItem } from '../SelectableItemList'

export type RenderItemProps<T> = {
  itemElementProps: React.ComponentProps<typeof Cell>
  isSelected: boolean
  item: SelectableListItem<T>
  button: ReactComponentElement<typeof Checkbox> | ReactComponentElement<typeof Radio>
}

type Props<T> = {
  groups: Array<FilterGroupModel<T>>
  selectedIds: Array<number>
  name: string
  isMultiSelect: boolean
  onItemClick: (itemId: number) => void
  renderItem?: (props: RenderItemProps<T>) => ReactNode
}

const FilterGroupList = <T,>({
  groups,
  selectedIds,
  name,
  isMultiSelect,
  onItemClick,
  renderItem,
}: Props<T>) => {
  const handleItemClick = (item: SelectableListItem<T>) => {
    onItemClick(Number(item.id))
  }

  const renderGroup = (group: FilterGroupModel<T>, index: number) => {
    const labelType = index === 0 ? 'leading' : 'stacked'
    const items = group.items.map(({ id, title, data }) => ({
      id,
      title,
      value: id,
      data,
    }))

    return (
      <div key={group.id}>
        <Label text={<Text as="h3" text={group.description} type="subtitle" />} type={labelType} />
        <SelectableItemList
          name={`${name}_${String(group.id)}`}
          isMultiSelect={isMultiSelect}
          items={items}
          selected={selectedIds}
          renderItem={renderItem}
          onItemClick={handleItemClick}
          itemButtonTestId="filter-group-list"
          disableButtonClicks
        />
      </div>
    )
  }

  return <>{groups.map((group, index) => renderGroup(group, index))}</>
}

export default FilterGroupList
